import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NotifierModule } from 'angular-notifier';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BaseComponent } from './base/base.component';
import { notifierCustomOptions } from './notifier-custom-options';
import { AlertModule } from './shared/components/alert/alert.module';
import { EnterPinDialogModule } from './shared/components/enter-pin-dialog/enter-pin-dialog.module';
import { HeaderModule } from './shared/components/header/header.module';
import { LockScreenDialogModule } from './shared/components/lock-screen-dialog/lock-screen-dialog.module';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { PendingTransactionMessageModule } from './shared/components/pending-transaction-message/pending-transaction-message.module';
import { PillLoaderModule } from './shared/components/pill-loader/pill-loader.module';
import { RecordDetailsWidgetModule } from './shared/components/record-details-widget/record-details-widget.module';
import { ResetPinDialogModule } from './shared/components/reset-pin-dialog/reset-pin-dialog.module';
import { SidebarMenuModule } from './shared/components/sidebar-menu/sidebar-menu.module';
import { BaseTableDirective } from './shared/directives/base-table.directive';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { HeaderInterceptor } from './shared/interceptors/header.interceptor';
import { HostInterceptor } from './shared/interceptors/host.interceptor';
import { TimeHeadersInterceptor } from './shared/interceptors/time-headers.interceptor';
import { CustomErrorHandler } from './shared/services/custom-error.handler';
import { ApplicationState } from './shared/states/application/application.state';
import { AuditsState } from './shared/states/audits/audits.state';
import { AuthState } from './shared/states/auth/auth.state';
import { DrugsState } from './shared/states/drugs/drugs.state';
import { InventoryState } from './shared/states/inventory/inventory.state';
import { OrdersState } from './shared/states/orders/orders.state';
import { PharmacyState } from './shared/states/pharmacy/pharmacy.state';
import { ProfileState } from './shared/states/profile/profile.state';
import { ReportsState } from './shared/states/reports/reports.state';
import { SettingsState } from './shared/states/settings/settings.state';
import { TransactionsState } from './shared/states/transactions/transactions.state';
import { UserMessageState } from './shared/states/user-message/user-message.state';
import { UserMessageDialogModule } from './shared/components/user-message-dialog/user-message-dialog.module';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    BaseComponent,
    BaseTableDirective,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HeaderModule,
    SidebarMenuModule,
    NgxsModule.forRoot([
      AuthState,
      ProfileState,
      PharmacyState,
      OrdersState,
      DrugsState,
      TransactionsState,
      InventoryState,
      ReportsState,
      AuditsState,
      SettingsState,
      ApplicationState,
      UserMessageState
    ]
    , {
      developmentMode: !environment.production, // prevent deep freeze of state so I can update a child row.
    }),
    NgxsStoragePluginModule.forRoot({
      storage: StorageOption.LocalStorage
    }),
    NgxsResetPluginModule.forRoot(),
    // NgxsLoggerPluginModule.forRoot({
    //   disabled: environment.production
    // }),
    RecordDetailsWidgetModule,
    AlertModule,
    NotifierModule.withConfig(notifierCustomOptions),
    LockScreenDialogModule,
    ResetPinDialogModule,
    PendingTransactionMessageModule,
    PillLoaderModule,
    EnterPinDialogModule,
    UserMessageDialogModule
  ],
  providers: [
    // do not change order
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeHeadersInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
